
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material"
import { iconos } from "../../data";
import { LineaSeparadora } from "../components";






export const DisenioPaginas = ({ children, titulo, subtitulo=null, add=true, url, disabled=false }) => {


    const navigate = useNavigate();


    const handleGoRoute = () => {
        if(!isNaN(url)) {
            navigate(url * -1)
        }else {
            navigate(`/admin/${url}`)
        }
    }



    return (


        <Box sx={{ display:'flex', flexDirection:'column', width:'100%', height:'100%',
            backgroundColor:'white', p:4, minHeight:0, overflowY:'auto', overflowX:'hidden',
        }}>
            {/* Header */}
            <Box sx={{ display:'flex', alignItems:'center', mb:2, width:'100%', flexShrink:0 }}>
                <Typography variant="h4"> { titulo } </Typography>

                <Box sx={{ flex:1 }} />

                {(add) 
                ?   <Button variant="contained"  disabled={disabled} onClick={handleGoRoute}
                        sx={{ color:'#fff', ':hover': {opacity:0.5}, py:1 }} color="secondary"
                    >
                        {iconos['plus']}
                    </Button>

                :   <Button variant="contained" color="secondary" onClick={handleGoRoute}
                        sx={{ color: '#fff', ':hover': { opacity: 0.5 }, py: 1 }}
                    >
                        { iconos['back'] }
                    </Button>
                }
            </Box>

            {/* Subtítulo */}
            {(subtitulo) &&
                <Box sx={{ flexShrink:0, mb:3 }}>
                    <Box sx={{ display:'flex', alignItems:'center', color:'#8B8B8B' }}>
                        { iconos['setting'] }
                        <Typography variant="h5" sx={{ ml:0.5, color:'#8B8B8B' }}>
                            { subtitulo }
                        </Typography>
                    </Box>
                    <LineaSeparadora top={1} />
                </Box>
            }

            {/* Contenido */}
            <Box sx={{ flex:1, display:'flex', flexDirection:'column' }}>
                {children}
            </Box>

        </Box>

    )
}
